module.exports = __webpack_public_path__ + "img/icon-card-shopping.e5d47b9b.svg";